import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import { ShieldCheck, X } from 'lucide-react';

const CONSENT_KEY = 'app_consent_v1';

export default function ConsentBanner() {
  const { lang } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem(CONSENT_KEY);
    if (!accepted) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, new Date().toISOString());
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="consent-banner"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 sm:max-w-sm z-50 animate-fade-in-up"
    >
      <div className="card-base p-5 shadow-lg border border-border bg-paper">
        <div className="flex items-start gap-3 mb-3">
          <div className="w-9 h-9 rounded-xl bg-sage-light flex items-center justify-center flex-shrink-0">
            <ShieldCheck size={16} className="text-sage" />
          </div>
          <div className="flex-1">
            <h3 className="font-heading text-sm font-semibold text-ink mb-1">
              {lang === 'zh' ? '关于你的资讯' : 'About your information'}
            </h3>
            <p className="text-xs text-ink-secondary leading-relaxed">
              {lang === 'zh'
                ? '我们仅在你的设备上保存语言偏好和自我检测进度，资料只在你提交后才会储存。继续浏览即表示同意。'
                : 'We only store your language preference and self-check progress on this device. Data is saved only when you submit. By continuing you agree.'}
            </p>
          </div>
          <button
            onClick={accept}
            data-testid="consent-close"
            className="p-1 text-ink-tertiary hover:text-ink"
            aria-label="Dismiss"
          >
            <X size={14} />
          </button>
        </div>
        <div className="flex gap-2">
          <button onClick={accept} data-testid="consent-accept" className="btn-primary flex-1 min-h-[40px] text-sm px-4">
            {lang === 'zh' ? '同意并继续' : 'Accept & continue'}
          </button>
          <Link
            to="/privacy"
            onClick={accept}
            data-testid="consent-details"
            className="btn-outline min-h-[40px] text-sm px-4"
          >
            {lang === 'zh' ? '详情' : 'Details'}
          </Link>
        </div>
      </div>
    </div>
  );
}
